import React from 'react';
import { useTranslation } from '@common/hooks/useTranslation';
import { Heading } from '@components/Heading';
import { SuccessIcon } from '@components/Icon';

export const HeaderInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col pt-[24px] p-lg items-center gap-md bg-background-neutral">
      <SuccessIcon size="xxxlarge" tone="success" variant="outline" />
      <Heading level="h1" weight="regular" align="center">
        {t('editJobSuccessPage.heading')}
      </Heading>
    </div>
  );
};
